<template>
  <div class="app-container table-container">
    <div v-if="hasPermi('select')" class="table-top-bar w100 flex jbetween acenter">
      <div class="table-top-left air-form flex acenter">
        <el-date-picker
          style="width: 160px; margin-right: 20px"
          v-model="year"
          type="year"
          format="yyyy年度"
          value-format="yyyy"
          placeholder="选择年份"
          :clearable="false"
          :editable="false"
          @change="getData(1)"
        ></el-date-picker>
        <air-tabs :tabs="tabs" :active.sync="activeTab" @tab-click="changeTab"></air-tabs>
      </div>
      <div class="table-top-operation flex jend acenter">
        <el-cascader
          class="table-top-operation-cascader"
          style="width: 195px; margin-right: 12px;"
          v-model="queryParams.orgIds"
          :options="orgTree"
          :props="{ multiple: true, checkStrictly: true, emitPath: false, value: 'id', label: 'orgName' }"
          :show-all-levels="false"
          collapse-tags
          clearable
          placeholder="组织机构"
          size="mini"
          @change="getTableData"></el-cascader>
        <el-input
          style="width: 160px; margin-right: 12px;"
          v-model="search"
          placeholder="搜索员工"
          suffix-icon="el-icon-search"
          @input="handleSearch"
          size="mini"
        />
        <el-button v-if="hasPermi('select')" plain @click="getTableData(1)">刷新</el-button>
        <el-button v-if="hasPermi('add')" plain @click="showEmpModal(false)">添加员工</el-button>
        <el-button v-if="hasPermi('delete')&&(year === $day().format('YYYY')|| parseInt(year) === parseInt($day().format('YYYY')) + 1 || (parseInt(year) === parseInt($day().format('YYYY')) - 1&&(month===1||month===2||month===3)) || parseInt(year) === parseInt($day().format('YYYY')) + 2)" plain @click="reCalculation" title="删除计算项目中的现有数据，重新计算">重新计算</el-button>
        <el-button v-if="hasPermi('update')" type="primary" @click="showLetterModal">Letter生成</el-button>
        <el-button v-if="hasPermi('update')" type="primary" @click="showMsRatioModal">MS系数</el-button>
        <el-button v-if="hasPermi('select')" type="primary" @click="handleExport">导出</el-button>
        <el-dropdown class="ml12" @command="handleCommand" v-if="hasPermi('add') || hasPermi('update') || hasPermi('delete')">
          <el-button type="primary">
            批量操作<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="batchInsert" v-if="hasPermi('add')">批量添加</el-dropdown-item>
            <el-dropdown-item command="batchUpdate" v-if="hasPermi('update')">批量编辑</el-dropdown-item>
            <el-dropdown-item command="batchDelete" v-if="hasPermi('delete')&&(year === $day().format('YYYY')|| parseInt(year) === parseInt($day().format('YYYY')) + 1 || (parseInt(year) === parseInt($day().format('YYYY')) - 1&&(month===1||month===2||month===3)) || parseInt(year) === parseInt($day().format('YYYY')) + 2)" :disabled="!checkedList.length" title="删除指定项目中的现有数据，重新计算">批量删除</el-dropdown-item>
            <el-dropdown-item command="batchDeleteElement" v-if="hasPermi('delete')&&(year === $day().format('YYYY')|| parseInt(year) === parseInt($day().format('YYYY')) + 1 || (parseInt(year) === parseInt($day().format('YYYY')) - 1&&(month===1||month===2||month===3)) || parseInt(year) === parseInt($day().format('YYYY')) + 2)" :disabled="!checkedList.length">批量清空项目</el-dropdown-item>
            <el-dropdown-item command="batchUpdateZjAndXz" v-if="hasPermi('update')&&(year === $day().format('YYYY')|| parseInt(year) === parseInt($day().format('YYYY')) + 1 || (parseInt(year) === parseInt($day().format('YYYY')) - 1&&(month===1||month===2||month===3)) || parseInt(year) === parseInt($day().format('YYYY')) + 2)" :disabled="!checkedList.length">晋升与调薪</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <!-- 晋升与调薪弹窗 -->
    <el-dialog
      class="air-modal"
      :title="promotionModal.title"
      :visible.sync="promotionModal.show"
      :close-on-click-modal="false"
      width="500px"
      append-to-body
      v-dialog-drag
    >
      <div class="air-modal-body flex vertical">
        <el-form
          ref="promotionFormRef"
          class="air-form"
          :model="promotionForm"
          :rules="promotionRules"
          style="margin-top: 20px"
        >
          <el-col :span="24">
            <el-form-item label="取值年度" prop="year">
              <el-date-picker
                v-model="promotionForm.year"
                type="year"
                format="yyyy年度"
                value-format="yyyy"
                placeholder="请选择年度"
                :picker-options="promotionYearPickerOptions"
                style="width: 100%"
                :clearable="false"
              />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="操作类型" prop="actionType">
              <el-radio-group v-model="promotionForm.actionType">
                <el-radio label="both">晋升与调薪</el-radio>
                <el-radio label="promotion">仅晋升</el-radio>
                <el-radio label="salary">仅调薪</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-form>
      </div>
      <div slot="footer" class="air-modal-footer flex jend acenter" style="margin-top: 20px">
        <el-button type="text" class="text-button-cancel" @click="promotionModal.show = false">
          取消
        </el-button>
        <el-button :loading="submitLoading" type="primary" @click="handlePromotionConfirm">
          确定
        </el-button>
      </div>
    </el-dialog>
    <air-table
      class="table-v2"
      v-if="hasPermi('select')"
      ref="airTable"
      :columns="columns"
      :data="tableData"
      :loading="loading"
      :show-operation="hasPermi('update') || hasPermi('delete')"
      :operation-column-width="160"
      :show-export-seq="showExportSeq"
      @checkbox-change="check"
      @checkbox-all="check"
      @header-icon-click="clickHeaderIcon"
      @change-filter="changeFilter"
    >
      <template #a0010002="{ row }">
        <div class="h100 flex center" @click="showEmpProfile(row)">
          <span class="link-text text-ellipsis">{{ row.a0010002 }}</span>
<!--          <el-tooltip popper-class="air-tooltip" effect="light" :content="row.a0010002" placement="bottom-start" :open-delay="700">-->
<!--            <span class="link-text text-ellipsis" @click="showEmpProfile(row)">{{ row.a0010002 }}</span>-->
<!--          </el-tooltip>-->
        </div>
      </template>
      <template #a0300751="{ row }">
        <div class="h100 flex center jend" @click="showRatingDetails(row)">
          <span class="link-text text-ellipsis">{{ $showMoney(row.a0300751) }}</span>
        </div>
      </template>
      <template #a0300786="{ row }">
        <div class="h100 flex center jend" @click="showBonusDetails(row)">
          <span class="link-text text-ellipsis">{{ $showMoney(row.a0300786) }}</span>
        </div>
      </template>
      <template #operation="{ row }">
        <div class="table-operation flex center">
          <el-button v-if="hasPermi('update')" type="text" @click="showEmpModal(row)">编辑</el-button>
          <div v-if="hasPermi('update') && hasPermi('delete')" class="divider"></div>
          <el-button v-if="hasPermi('delete')" type="text" @click="handleDelete(row)">删除</el-button>
        </div>
      </template>
    </air-table>

    <!-- Metashares弹窗 -->
    <el-dialog class="air-modal" :title="metasharesModal.title" :visible.sync="metasharesModal.show" :close-on-click-modal="false" width="500px" append-to-body @closed="metasharesFormClosed" v-dialog-drag>
      <div class="air-modal-body flex vertical">
        <el-form ref="metasharesForm" class="air-form" :model="metasharesForm" :rules="metasharesRules" style="margin-top: 20px">
          <template v-if="metasharesForm.itemId === 'a0300722'">
            <el-col :span="24">
              <el-form-item label="effective date" prop="effectiveDate">
                <el-date-picker clearable size="small"
                                v-model="metasharesForm.effectiveDate"
                                type="date"
                                format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd"
                                :picker-options="effectiveDatePickerOptions"
                                placeholder="请选择 effective date">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </template>
          <template v-else>
            <el-col :span="24">
              <el-form-item label="起始日期" prop="itemMin">
                <el-date-picker clearable size="small"
                                v-model="metasharesForm.itemMin"
                                type="date"
                                value-format="yyyy-MM-dd"
                                :picker-options="metaStartPickerOptions"
                                placeholder="请选择起始日期">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="有效期" prop="period">
                <el-select v-model="metasharesForm.period" :disabled="!metasharesForm.itemMin" placeholder="请选择有效期" size="small" @change="changeMetaPeriod">
                  <el-option :value="12" label="一年" />
                  <el-option :value="18" label="一年半" />
                  <el-option :value="24" label="两年" />
                  <el-option :value="36" label="三年" />
                  <el-option :value="48" label="四年" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="结束日期" prop="itemMax">
                <el-date-picker clearable size="small"
                                v-model="metasharesForm.itemMax"
                                type="date"
                                value-format="yyyy-MM-dd"
                                :picker-options="metaEndPickerOptions"
                                placeholder="请选择结束日期">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="是否MS价值" prop="isMsValue">
                <el-select v-model="metasharesForm.isMsValue" placeholder="请选择" size="small">
                  <el-option value="10020002" label="否" />
                  <el-option value="10020001" label="是" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="Refresh 名称" prop="itemName">
                <el-input v-model="metasharesForm.itemName" placeholder="Refresh 名称" maxlength="50" size="small" />
              </el-form-item>
            </el-col>
          </template>
        </el-form>
      </div>
      <div slot="footer" class="air-modal-footer flex jend acenter" style="margin-top: 20px">
        <el-button type="text" class="text-button-cancel" @click="metasharesModal.show = false">取消</el-button>
        <el-button :loading="submitLoading" type="primary" @click="submitMetasharesForm">保存</el-button>
      </div>
    </el-dialog>

    <!-- 预测百分比弹窗 -->
    <el-dialog class="air-modal" :title="percentModal.title" :visible.sync="percentModal.show" :close-on-click-modal="false" width="500px" append-to-body v-dialog-drag>
      <div class="air-modal-body flex vertical">
        <el-form ref="percentForm" class="air-form" :model="percentForm" :rules="percentRules" style="margin-top: 20px">
          <el-col :span="24">
            <el-form-item :label="percentForm.label" prop="percent">
              <el-input-number style="width: 440px;" v-model="percentForm.percent" :min="0" :max="99999" :controls="false"  ></el-input-number>
            </el-form-item>
          </el-col>
        </el-form>
      </div>
      <div slot="footer" class="air-modal-footer flex jend acenter" style="margin-top: 20px">
        <el-button type="text" class="text-button-cancel" @click="percentModal.show = false">取消</el-button>
        <el-button :loading="submitLoading" type="primary" @click="submitPercentForm">保存</el-button>
      </div>
    </el-dialog>

    <!-- 当期 PSC Rating 记录弹窗 -->
    <el-dialog class="air-modal" :title="pscRatingModal.title" :visible.sync="pscRatingModal.show" :close-on-click-modal="false" width="500px" append-to-body @closed="pscRatingFormClosed" v-dialog-drag>
      <div class="air-modal-body flex vertical">
        <el-form ref="pscRatingForm" class="air-form" :model="pscRatingForm" :rules="pscRatingRules" style="margin-top: 20px" size="small">
          <el-col :span="24">
            <el-form-item label="年份" prop="year">
              <el-date-picker
                  v-model="pscRatingForm.year"
                  type="year"
                  value-format="yyyy"
                  placeholder="请选择年份">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="PSC Rating" prop="itemName">
              <el-input v-model="pscRatingForm.itemName" placeholder="请输入名称" maxlength="30" />
            </el-form-item>
          </el-col>
        </el-form>
      </div>
      <div slot="footer" class="air-modal-footer flex jend acenter" style="margin-top: 20px">
        <el-button type="text" class="text-button-cancel" @click="pscRatingModal.show = false">取消</el-button>
        <el-button :loading="submitLoading" type="primary" @click="submitPscRatingForm">保存</el-button>
      </div>
    </el-dialog>

    <!-- 添加/编辑员工弹窗 -->
    <el-dialog class="air-modal" :title="empModal.title" :visible.sync="empModal.show" :close-on-click-modal="false" width="872px" append-to-body @closed="empFormClosed" v-dialog-drag>
      <el-form ref="empForm" class="air-form" :model="empForm" :rules="empRules" style="height: calc(100vh - 300px)" size="small">
        <div class="emp-form-group">
          <el-row :gutter="80" type="flex" justify="space-between">
            <el-col :span="12">
              <el-form-item label="工号" prop="a0010001">
                <el-input v-model="empForm.a0010001" placeholder="请输入工号" maxlength="30" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="员工姓名" prop="a0010002">
                <el-input v-model="empForm.a0010002" placeholder="请输入姓名" maxlength="30" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="80" type="flex" justify="space-between">
            <el-col :span="12">
              <el-form-item label="身份证号" prop="a0010005">
                <el-input v-model="empForm.a0010005" placeholder="请输入身份证号" maxlength="30" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="入职时间" prop="a0010039">
                <el-date-picker clearable size="small"
                                v-model="empForm.a0010039"
                                type="date"
                                value-format="yyyy-MM-dd"
                                placeholder="请选择入职时间">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="80" type="flex" justify="space-between">
            <el-col v-if="empModal.edit" :span="12">
              <el-form-item v-show="empModal.edit" label="离职时间" prop="a0010040Date">
                <el-date-picker clearable size="small"
                                v-model="empForm.a0010040Date"
                                type="date"
                                value-format="yyyy-MM-dd"
                                placeholder="请选择离职时间">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="职务描述" prop="a0300752">
                <el-input v-model="empForm.a0300752" placeholder="请输入职务描述" maxlength="30" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="80" type="flex" justify="space-between">
            <el-col :span="12">
              <el-form-item label="现职级" prop="a0300706">
                <el-select v-model="empForm.a0300706" placeholder="请选择现职级" size="small" clearable filterable>
                  <el-option v-for="item in dict.a0300706" :key="item.value" :value="item.value" :label="item.label" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="晋升后职级" prop="a0300754">
                <el-select v-model="empForm.a0300754" placeholder="请选择晋升后职级" size="small" clearable filterable>
                  <el-option v-for="item in dict.a0300754" :key="item.value" :value="item.value" :label="item.label" />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="80" type="flex" justify="space-between">
            <el-col :span="12">
              <el-form-item label="办公地点" prop="a0300755">
                <el-input v-model="empForm.a0300755" placeholder="请输入办公地点" maxlength="30" />
              </el-form-item>
            </el-col>
            <el-col :span="12"></el-col>
          </el-row>
          <el-row :gutter="80" type="flex" justify="space-between">
            <el-col :span="12">
              <el-form-item label="一级部门" prop="a0300701">
                <el-select v-model="empForm.a0300701" placeholder="请选择一级部门" size="small" @change="changeOrg">
                  <el-option v-for="item in orgTree" :key="item.orgName" :value="item.orgName" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="二级部门" prop="a0300702">
                <el-select v-model="empForm.a0300702" placeholder="请选择二级部门" size="small" @change="changeDept">
                  <el-option v-for="item in deptTree" :key="item.orgName" :value="item.orgName" />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="80" type="flex" justify="space-between">
            <el-col :span="12">
              <el-form-item label="三级部门" prop="a0300703">
                <el-select v-model="empForm.a0300703" placeholder="请选择三级部门" size="small" @change="change2Dept">
                  <el-option v-for="item in dept2Tree" :key="item.orgName" :value="item.orgName" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="四级部门" prop="a0300758">
                <el-select v-model="empForm.a0300758" placeholder="请选择四级部门" size="small" >
                  <el-option v-for="item in dept3Tree" :key="item.orgName" :value="item.orgName" />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="80" type="flex" justify="space-between">
            <el-col :span="12">
              <el-form-item label="员工类型" prop="a0300756">
                <el-select v-model="empForm.a0300756" placeholder="请选择员工类型" size="small" clearable filterable>
                  <el-option v-for="item in dict.a0300756" :key="item.label" :value="item.label" :label="item.label" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="员工组织类别" prop="a0300757">
                <el-select v-model="empForm.a0300757" placeholder="请选择员工组织类别" size="small" clearable filterable>
                  <el-option v-for="item in dict.a0300757" :key="item.label" :value="item.label" :label="item.label" />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="80" type="flex" justify="space-between">
            <el-col :span="12">
              <el-form-item label="PNL 类型" prop="a0300756">
                <el-select v-model="empForm.a0300782" placeholder="请选择PNL 类型" size="small" clearable filterable>
                  <el-option v-for="item in dict.a0300782" :key="item.label" :value="item.label" :label="item.label" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="请输入PNL 系数" prop="a0300797">
                <el-input v-model="empForm.a0300797" maxlength="14" placeholder="请输入PNL 系数" ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="80" type="flex" justify="space-between">
            <el-col :span="12">
              <el-form-item label="币种" prop="a0300757">
                <el-select v-model="empForm.a0300783" placeholder="请选择币种" size="small" clearable filterable>
                  <el-option v-for="item in dict.a0300783" :key="item.label" :value="item.label" :label="item.label" />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="80" type="flex" justify="space-between">
            <el-col :span="12">
              <el-form-item label="绩效结果-年中" prop="a0300707">
                <el-select v-model="empForm.a0300707" placeholder="请选择" size="small" readonly clearable>
                  <el-option v-for="item in dict.a0300707" :key="item.value" :value="item.value" :label="item.label" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="绩效结果-年末" prop="a0300708">
                <el-select v-model="empForm.a0300708" placeholder="请选择" size="small" readonly clearable>
                  <el-option v-for="item in dict.a0300708" :key="item.value" :value="item.value" :label="item.label" />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="80" type="flex" justify="space-between">
            <el-col :span="12">
              <el-form-item label="ㅤ" class="flex vertical">
                <el-checkbox style="margin-right: 0" v-model="empForm.a0300753" label="是否增加上一年度PSC未计算奖金" true-label="是" false-label=""></el-checkbox>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item v-if="empModal.edit" label="入职时间系数" prop="a0300705">
                <el-input v-model="empForm.a0300705" maxlength="14" placeholder="请输入入职时间系数" ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="empModal.edit" :gutter="80" type="flex" justify="space-between">
            <el-col :span="12">
              <el-form-item v-if="empModal.edit" label="H1 PSC时间系数" prop="a0300710">
                <el-input v-model="empForm.a0300710" maxlength="14" placeholder="请输入H1 PSC时间系数" ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item v-if="empModal.edit" label="H2 PSC时间系数" prop="a0300777">
                <el-input v-model="empForm.a0300777" maxlength="14" placeholder="请输入H2 PSC时间系数" ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <div class="emp-form-group">
          <el-row :gutter="80" type="flex" justify="space-between">
            <el-col :span="12">
              <el-form-item label="1-2月基本工资" prop="a0300784">
                <el-input-number v-model="empForm.a0300784" :min="0" :max="9999999999" :controls="false" :precision="2" placeholder="请输入1-2月基本工资" ></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="3-6月基本工资" prop="a0300785">
                <el-input-number v-model="empForm.a0300785" :min="0" :max="9999999999" :controls="false" :precision="2" placeholder="请输入3-6月基本工资" ></el-input-number>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="80" type="flex" justify="space-between">
            <el-col :span="12">
              <el-form-item label="现月基本工资" prop="a0300711">
                <el-input-number v-model="empForm.a0300711" :min="0" :max="9999999999" :controls="false" :precision="2" placeholder="请输入现月基本工资" ></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="调薪后月基本工资" prop="a0300709">
                <el-input-number v-model="empForm.a0300709" :min="0" :max="9999999999" :controls="false" :precision="2" placeholder="请输入调薪后月基本工资" ></el-input-number>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="80" type="flex" justify="space-between">
            <el-col :span="12">
              <el-form-item label="额外奖金" prop="a0300713">
                <el-input-number v-model="empForm.a0300713" :min="0" :max="9999999999" :controls="false" :precision="2" placeholder="请输入额外奖金" ></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Res Bonus 总包" prop="a0300760">
                <el-input-number v-model="empForm.a0300760" :min="0" :max="9999999999" :controls="false" :precision="2" placeholder="请输入Res Bonus 总包" ></el-input-number>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="empModal.edit" :gutter="80" type="flex" justify="space-between">
            <el-col :span="12">
              <el-form-item v-if="empModal.edit" label="Res Bonus 当期折算" prop="a0300761">
                <el-input v-model="empForm.a0300761" maxlength="14" placeholder="请输入Res Bonus 当期折算" ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item v-if="empModal.edit" label="PSC奖金" prop="a0300712">
                <el-input v-model="empForm.a0300712" maxlength="14" placeholder="请输入PSC奖金" ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="80" type="flex" justify="space-between">
            <el-col :span="12">
              <el-form-item label="Sales 销售分红" prop="a0300762">
                <el-input-number v-model="empForm.a0300762" :min="0" :max="9999999999" :controls="false" placeholder="请输入Sales 销售分红" ></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="12"></el-col>
          </el-row>
          <el-row :gutter="80" type="flex" justify="space-between">
            <el-col :span="12">
              <el-form-item label="永久性（单位：份）" prop="a0300715">
                <el-input-number v-model="empForm.a0300715" :min="0" :max="9999999999" :controls="false" :precision="2" placeholder="请输入永久性（单位：份）" ></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="12"></el-col>
          </el-row>
          <el-row :gutter="80" type="flex" justify="space-between">
            <el-col :span="12">
              <el-form-item label="入职初始（有效期两年)（单位：份）" prop="a0300716">
                <el-input-number v-model="empForm.a0300716" :min="0" :max="9999999999" :controls="false" :precision="2" placeholder="请输入入职初始（有效期两年)（单位：份）" ></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="有效期至" prop="a0300718">
                <el-date-picker clearable size="small"
                                v-model="empForm.a0300718"
                                type="date"
                                value-format="yyyy-MM-dd"
                                placeholder="请选择日期">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex" justify="space-between" style="flex-wrap: wrap">
            <el-col v-for="(item, index) in refresherColumns" :key="index" :span="12">
              <el-form-item :label="item.itemName" :prop="item.itemId" :style="{ 'padding-right': index % 2 === 0 ? '40px' : '0', 'padding-left': index % 2 === 1 ? '40px' : '0' }">
                <el-input-number v-model="empForm[item.itemId]" :min="0" :max="9999999999" :controls="false"  placeholder="请输入" ></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="12"></el-col>
          </el-row>
          <el-row v-if="empModal.edit" :gutter="80" type="flex" justify="space-between">
            <el-col :span="12">
              <el-form-item v-if="empModal.edit" label="effective Metashares（单位：份）" prop="a0300722">
                <el-input v-model="empForm.a0300722" maxlength="14" placeholder="请输入effective Metashares（单位：份）" ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12"></el-col>
          </el-row>
          <el-row :gutter="80" type="flex" justify="space-between">
            <el-col :span="12">
              <el-form-item label="ㅤ" class="flex vertical">
                <el-checkbox style="margin-right: 0" v-model="empForm.a0300764" label="入职第一年是否保证1元收益" true-label="是" false-label="否"></el-checkbox>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item v-if="empModal.edit" label="Metashars 收益（不含绩效）" prop="a0300729">
                <el-input v-model="empForm.a0300729" maxlength="14" placeholder="请输入Metashars 收益（不含绩效）" ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="80" type="flex" justify="space-between">
            <el-col :span="12">
              <el-form-item label="Goliath数量(永久性）" prop="a0300732">
                <el-input-number v-model="empForm.a0300732" :min="0" :max="9999999999" :controls="false" :precision="2" placeholder="请输入Goliath数量(永久性）" ></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item v-if="empModal.edit" label="Goliath预测收益率（单位：元）" prop="a0300733">
                <el-input v-model="empForm.a0300733" maxlength="14" placeholder="请输入Goliath预测收益率（单位：元）" ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="80" type="flex" justify="space-between">
            <el-col v-if="empModal.edit" :span="12">
              <el-form-item v-if="empModal.edit" label="当期年度 Package 数据（PSC取真实数据）" prop="a0300735">
                <el-input v-model="empForm.a0300735" maxlength="14" placeholder="请输入当期年度 Package 数据（PSC取真实数据）" ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="当期年度 Package 预测 PSC Rating系数-ME" prop="a0300736">
                <el-input v-model="empForm.a0300736" maxlength="14" placeholder="请输入当期年度 Package 预测 PSC Rating系数-ME" ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="empModal.edit" :gutter="80" type="flex" justify="space-between">
            <el-col :span="12">
              <el-form-item v-if="empModal.edit" label="当期年度 Package测算（PSC取ME系数测算数据）" prop="a0300737">
                <el-input v-model="empForm.a0300737" maxlength="14" placeholder="当期年度 Package测算（PSC取ME系数测算数据）" ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12"></el-col>
          </el-row>
          <el-row v-if="empModal.edit" :gutter="80" type="flex" justify="space-between">
            <el-col :span="12">
              <el-form-item v-if="empModal.edit" label="Package额度设定（用于测算跟投额度）" prop="a0300738">
                <el-input v-model="empForm.a0300738" maxlength="14" placeholder="请输入Package额度设定（用于测算跟投额度）" ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item v-if="empModal.edit" label="跟投额度系数" prop="a0300765">
                <el-input v-model="empForm.a0300765" maxlength="14" placeholder="请输入跟投额度系数" ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="80" type="flex" justify="space-between">
            <el-col v-if="empModal.edit" :span="12">
              <el-form-item v-if="empModal.edit" label="跟投额度" prop="a0300766">
                <el-input v-model="empForm.a0300766" maxlength="14" placeholder="请输入跟投额度" ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="特批跟投额度" prop="a0300767">
                <el-input-number v-model="empForm.a0300767" :min="0" :max="9999999999" :controls="false" placeholder="请输入特批跟投额度" ></el-input-number>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="empModal.edit" :gutter="80" type="flex" justify="space-between">
            <el-col :span="12">
              <el-form-item v-if="empModal.edit" label="最终跟投额度" prop="a0300768">
                <el-input v-model="empForm.a0300768" maxlength="14" placeholder="请输入最终跟投额度" ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
            </el-col>
          </el-row>
          <el-row :gutter="80" type="flex" justify="space-between">
            <el-col :span="12">
              <el-form-item label="历史应发奖金数据" prop="a0300779">
                <el-input-number v-model="empForm.a0300779" :min="0" :max="9999999999" :controls="false" :precision="2" placeholder="请输入历史应发奖金数据" ></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item v-if="empModal.edit" label="往年递延至本年度应发奖金" prop="a0300780">
                <el-input v-model="empForm.a0300780" maxlength="14" placeholder="请输入往年递延至本年度应发奖金" ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="80" type="flex" justify="space-between">
            <el-col v-if="empModal.edit" :span="12">
              <el-form-item v-if="empModal.edit" label="本年度奖金及分红合计" prop="a0300769">
                <el-input v-model="empForm.a0300769" maxlength="14" placeholder="请输入本年度奖金及分红合计" ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="ㅤ" class="flex vertical">
                <el-checkbox style="margin-right: 0" v-model="empForm.a0300770" label="本年度奖金是否参与递延发放" true-label="是" false-label="否"></el-checkbox>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="empModal.edit" :gutter="80" type="flex" justify="space-between">
            <el-col :span="12">
              <el-form-item v-if="empModal.edit" label="递延发放奖金及分红金额" prop="a0300771">
                <el-input v-model="empForm.a0300771" maxlength="14" placeholder="请输入递延发放奖金及分红金额" ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item v-if="empModal.edit" label="第一期发放金额" prop="a0300772">
                <el-input v-model="empForm.a0300772" maxlength="14" placeholder="请输入第一期发放金额" ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="empModal.edit" :gutter="80" type="flex" justify="space-between">
            <el-col :span="12">
              <el-form-item v-if="empModal.edit" label="递延第二期发放金额" prop="a0300773">
                <el-input v-model="empForm.a0300773" maxlength="14" placeholder="请输入递延第二期发放金额" ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item v-if="empModal.edit" label="递延第三期发放金额" prop="a0300774">
                <el-input v-model="empForm.a0300774" maxlength="14" placeholder="请输入递延第三期发放金额" ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="empModal.edit" :gutter="80" type="flex" justify="space-between">
            <el-col :span="12">
              <el-form-item v-if="empModal.edit" label="本年度发放奖金及分红" prop="a0300775">
                <el-input v-model="empForm.a0300775" maxlength="14" placeholder="请输入本年度发放奖金及分红" ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item v-if="empModal.edit" label="本年度发放奖金稽核" prop="a0300776">
                <el-input v-model="empForm.a0300776" maxlength="14" placeholder="请输入本年度发放奖金稽核" ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="80" type="flex" justify="space-between">
            <el-col v-if="empModal.edit" :span="12">
              <el-form-item v-if="empModal.edit" label="本年度发放奖金合计" prop="a0300781">
                <el-input v-model="empForm.a0300781" placeholder="请输入本年度发放奖金合计" maxlength="14"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
            </el-col>
          </el-row>
          <el-row :gutter="80" type="flex" justify="space-between">
            <el-col v-if="empModal.edit" :span="12">
              <el-form-item v-if="empModal.edit" label="本年度失效Metashars份数" prop="a0300751">
                <el-input v-model="empForm.a0300751" maxlength="14" placeholder="请输入本年度失效Metashars份数" ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="备注" prop="a0300778">
                <el-input v-model="empForm.a0300778" placeholder="请输入备注" maxlength="50" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex" justify="space-between" style="flex-wrap: wrap">
            <el-col v-for="(item, index) in pscRatingColumns" :key="index" :span="12">
              <el-form-item :label="item.itemName" :prop="item.itemId" :style="{ 'padding-right': index % 2 === 0 ? '40px' : '0', 'padding-left': index % 2 === 1 ? '40px' : '0' }">
                <el-select v-model="empForm[item.itemId]" placeholder="请选择" size="small" clearable filterable>
                  <el-option v-for="item in dict.a0300707" :key="item.value" :value="item.value" :label="item.label" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12"></el-col>
          </el-row>
        </div>

      </el-form>
      <div slot="footer" class="air-modal-footer flex jend acenter mt20">
        <el-button type="text" class="text-button-cancel" @click="empModal.show = false">取消</el-button>
        <el-button :loading="submitLoading" type="primary" @click="submitEmpForm">保存</el-button>
      </div>
    </el-dialog>

    <!-- 员工成长档案弹窗 -->
    <el-dialog class="air-modal" title="员工成长档案" :visible.sync="profileModalShow" :close-on-click-modal="false" width="550px" append-to-body v-dialog-drag>
      <div class="air-modal-body flex vertical" style="height: 375px;">
        <div class="profile-box">
          <div class="flex aend mb16">
            <span class="font-20 mr10">{{ profile.employee[0].a0010002 }}</span>
            <span class="font-12">{{ profile.employee[0].a0010001 }}</span>
          </div>
          <span class="font-12 text-left">{{ profile.employee[0].b0010009 }}</span>
        </div>
        <div class="profile-box">
          <span class="font-12 text-left mb20 fw-600">级别变动</span>
          <div v-for="item in profile.level" class="flex mb16">
            <span class="font-12 mr16">{{ item.createTime }}</span>
            <span class="font-12 mr16">{{ item.a0300706 }}</span>
            <span v-if="item.canmodify === '10020001'" class="font-12 color-primary pointer" @click="revokeLevel(item)">撤销</span>
          </div>
        </div>
        <div class="profile-box">
          <span class="font-12 text-left mb20 fw-600">月基本工资调整记录</span>
          <div v-for="item in profile.basySalary" class="flex mb16">
            <span class="font-12 mr16">
              <template v-if="item.isEdit==='10020002'">
                {{item.createTime}}
              </template>
              <template v-if="item.isEdit==='10020001'">
                {{ $day(item.createTime).format('YYYY-MM-DD') }}
              </template>
            </span>
            <span class="font-12 mr16">{{ $formatMoney(item.a0300711) }}</span>
            <span v-if="item.canmodify === '10020001'" class="font-12 color-primary pointer" @click="revokeSalary(item)">撤销</span>
          </div>
        </div>
        <div class="profile-box" style="margin-bottom: 0">
          <span class="font-12 text-left mb20 fw-600">历史 PSC Rating</span>
          <div v-for="item in profile.rating" class="flex vertical">
            <div class="flex jbetween mb20 rating-line">
              <div v-if="item.a0300708" class="flex jbetween">
                <span class="font-12">{{ item.a0300708 }}</span>
                <span class="font-12 color-warning">{{ item.a0300708Rating }}</span>
              </div>
            </div>
            <div class="flex jbetween mb20 rating-line">
              <div v-if="item.a0300707" class="flex jbetween">
                <span class="font-12">{{ item.a0300707 }}</span>
                <span class="font-12 color-warning">{{ item.a0300707Rating }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="air-modal-footer flex jend acenter">
        <el-button type="text" class="text-button-cancel" @click="profileModalShow = false">关闭</el-button>
      </div>
    </el-dialog>

    <!-- 导入 -->
    <el-dialog class="air-modal upload-modal" :title="upload.title" :visible.sync="upload.show" :close-on-click-modal="false" width="420px" append-to-body @close="cancelUpload" v-dialog-drag>
      <div class="upload-container flex vertical">
        <el-upload
          ref="upload"
          drag
          :limit="1"
          accept=".xlsx, .xls"
          :headers="upload.headers"
          :data="upload.data"
          :action="upload.url"
          :disabled="upload.isUploading"
          :on-progress="handleFileUploadProgress"
          :on-success="handleFileSuccess"
          :auto-upload="false"
        >
          <div class="upload-body flex vertical acenter">
            <img src="@/air/assets/img/icon/excel.png" />
            <el-button plain>上传文件</el-button>
            <span class="upload-tips">将文件拖到此处或点击上传，仅支持xls或xlsx文件。</span>
          </div>
        </el-upload>
      </div>
      <div slot="footer" class="air-modal-footer flex jbetween acenter">
        <el-button plain @click="importTemplate">下载模板</el-button>
        <div>
          <el-button type="text" class="text-button-cancel" @click="cancelUpload">取消</el-button>
          <el-button :loading="submitLoading" type="primary" @click="submitFileForm">确定</el-button>
        </div>
      </div>
    </el-dialog>

    <!-- Letter生成弹窗 -->
    <el-dialog class="air-modal letter-modal" title="Letter生成" :visible.sync="letterModal.show" :close-on-click-modal="false" width="710px" append-to-body v-dialog-drag>
      <el-form ref="empForm" class="air-form" :model="letterForm" :rules="letterRules" style="height: 375px;">
        <div style="height: calc(100vh - 300px); overflow: hidden auto; padding-right: 20px">
          <div class="letter-form-group">
            <el-row>
              <el-col :span="10">
                <el-form-item label="Letter模板" prop="title">
                  <el-select v-model="letterForm.id" placeholder="请选择模板" size="small" @change="changeLetter">
                    <el-option v-for="item in letterForm.letterId" :key="item.id" :value="item.id" :label="item.letterName" />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="10" style="padding-left: 20px">
                <el-form-item label="Letter所属期" prop="content">
                  <el-select v-model="letterForm.schedule" placeholder="请选择所属期" size="small" >
                    <el-option key="middle" value="middle" label="年中" />
                    <el-option key="end" value="end" label="年终" />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

          </div>
          <div class="letter-form-group">
            <el-row>
              <el-col :span="24">
                <el-form-item label="标题" prop="title">
                  <el-input ref="titleInput" v-model="letterForm.title" placeholder="请输入标题" maxlength="200" @blur="blurLetterInput('title', $event)" />
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <div class="letter-form-group">
            <el-row>
              <el-col :span="24">
                <el-form-item label="正文" prop="content">
                  <el-input ref="contentInput" type="textarea" v-model="letterForm.content" placeholder="请输入正文" maxlength="2000" :rows="4" @blur="blurLetterInput('content', $event)" />
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <div class="letter-form-group checkbox">
            <el-row>
              <el-col :span="24">
                <el-form-item label="数据" prop="isNull" class="flex vertical">
                  <el-checkbox style="margin-right: 0" v-model="letterForm.isNull" label="空值不显示" true-label="10020001" false-label="10020002"></el-checkbox>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <div class="letter-form-group">
            <el-row>
              <el-col :span="24">
                <el-form-item label="落款" prop="sign">
                  <el-input ref="signInput" type="textarea" v-model="letterForm.sign" placeholder="请输入落款" maxlength="2000" :rows="4" @blur="blurLetterInput('sign', $event)" />
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <div class="letter-form-group">
            <el-row>
              <el-col :span="24">
                <el-form-item label="落款日期" prop="signDate">
                  <template>
                    <div class="flex acenter">
                      <el-date-picker
                        :key="signDateType"
                        v-model="letterForm.signDate"
                        :type="signDateType"
                        placeholder="选择日期"
                        :format="signDateType === 'month' ? 'yyyy年M月' : 'yyyy年M月d日'"
                        :value-format="signDateType === 'month' ? 'yyyy年M月' : 'yyyy年M月d日'"
                        :clearable="true"
                        style="width: 200px; margin-right: 10px;"
                      >
                      </el-date-picker>
                      <el-radio-group v-model="signDateType" size="mini" @change="handleDateTypeChange">
                        <el-radio-button label="month">月份</el-radio-button>
                        <el-radio-button label="date">日期</el-radio-button>
                      </el-radio-group>
                    </div>
                  </template>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <div class="letter-form-group">
            <el-row>
              <el-col :span="24">
                <el-form-item label="附表" prop="attr">
                  <el-input ref="attrInput" type="textarea" v-model="letterForm.attr" placeholder="请输入附表" maxlength="2000" :rows="4" @blur="blurLetterInput('attr', $event)" />
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="letter-form-group pr20 mt10">
          <el-row>
            <el-col :span="24">
              <el-form-item label="可替换字段" prop="field" class="flex vertical">
                <div class="item-group full flex wrap">
                  <div v-for="item in letterFieldList" class="letter-field-item flex center mb20 mr20 pl12 pr12 pointer" @click="addLetterField(item)">
                    <span class="font-12 color-3 text-ellipsis">{{ item.itemName }}</span>
                  </div>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
      <div slot="footer" class="air-modal-footer flex jend acenter">
        <el-button type="text" class="text-button-cancel" @click="letterModal.show = false">取消</el-button>
        <el-button :loading="submitLoading" type="primary" @click="submitLetterFormOnly">保存模板</el-button>
        <el-button :loading="submitLoading" type="primary" @click="submitLetterForm">生成并下载</el-button>
      </div>
    </el-dialog>

    <!-- 查看本年度失效Metashars份数详情 -->
    <el-dialog class="air-modal" title="本年度失效Metashars份数详情" :visible.sync="ratingModal.show" :close-on-click-modal="false" width="550px" append-to-body @closed="ratingModalClosed" v-dialog-drag>
      <div class="air-modal-body flex vertical" style="height: 375px;">
        <air-table
          ref="airTableRating"
          :loading="loadingRating"
          :columns="columnsRating"
          :data="tableDataRating"
          :show-checkbox="false"
          :show-operation="false"
          :show-export-seq="false"
          align="center"
        >
        </air-table>
      </div>
      <div slot="footer" class="air-modal-footer flex jend acenter">
        <el-button type="text" class="text-button-cancel" @click="ratingModal.show = false">关闭</el-button>
      </div>
    </el-dialog>
    <!-- 查看本年度待发放奖金明细 -->
    <el-dialog class="air-modal" title="待发放奖金明细" :visible.sync="bonusModal.show" :close-on-click-modal="false" width="550px" append-to-body @closed="bonusModalClosed" v-dialog-drag>
      <div class="air-modal-body flex vertical" style="height: 375px;">
        <air-table
          ref="airTableBonus"
          :loading="loadingBonusDetails"
          :columns="columnsBonusDetails"
          :data="tableDataBonusDetails"
          :show-checkbox="false"
          :show-operation="false"
          :show-export-seq="false"
          align="center"
        >
        </air-table>
      </div>
      <div slot="footer" class="air-modal-footer flex jend acenter">
        <el-button type="text" class="text-button-cancel" @click="bonusModal.show = false">关闭</el-button>
      </div>
    </el-dialog>
    <el-dialog class="air-modal" title="请选择需要清空的项目"  :visible.sync="deleteElementShow" :close-on-click-modal="false" width="550px" append-to-body @closed="deleteElementClosed" v-dialog-drag>
      <div class="air-modal-body flex vertical" style="height: 400px;">
        <el-popover
          placement="bottom"
          width="450"
          trigger="click">
          <el-alert class="pointer" :title="deleteElementConfirmContext" type="warning" show-icon :closable="false" slot="reference"></el-alert>
          <div class="flex delete-element" style="max-height: 300px; overflow-y: auto; flex-wrap: wrap">
            <div class="delete-element-item" style="color: #e6a23c; font-size: 12px ; padding: 3px 0 ;width: 20%; text-align: center" v-for="emp in deleteElementEmps" :key="emp.a0010001">「{{ emp.a0010002 }}」</div>
          </div>
        </el-popover>
        <div class="delete-element-checked">
          <el-checkbox-group class="checkbox-group-v2 vertical" v-model="deleteElementsChecked" >
            <el-checkbox v-for="item in deleteElementsData" :key="item.field" :label="item">{{ item['title'] }}</el-checkbox>
          </el-checkbox-group>
        </div>
      </div>
      <div slot="footer" class="air-modal-footer flex jend acenter">
        <el-button type="text" class="text-button-cancel" @click="deleteElementShow = false">取消</el-button>
        <el-button :loading="submitLoading" type="primary" @click="deleteElementsByEmps">确认</el-button>
      </div>
    </el-dialog>
    <!-- MS系数管理弹窗 -->
    <el-dialog
      class="air-modal"
      :title="msRatioModal.title"
      :visible.sync="msRatioModal.show"
      :close-on-click-modal="false"
      width="900px"
      append-to-body
      v-dialog-drag
    >
      <div class="air-modal-body flex vertical" style="height: 375px;">
        <!-- 搜索和操作区域 -->
        <div class="table-top-bar w100 flex jbetween acenter mb20">
          <div class="table-top-left air-form flex acenter">
            <el-date-picker
              style="width: 160px; margin-right: 20px"
              v-model="msRatioQueryParams.year"
              type="year"
              format="yyyy年度"
              value-format="yyyy"
              placeholder="选择年度"
              :clearable="true"
              :editable="false"
              @change="handleMsRatioYearChange"
            ></el-date-picker>
          </div>
          <div class="table-top-operation flex jend acenter">
            <el-button
              v-if="hasPermi('add')"
              type="primary"
              @click="handleAddMsRatio"
            >
              添加
            </el-button>
            <el-button
              v-if="hasPermi('add') && this.msRatioTableData.length == 0"
              type="primary"
              @click="handleCopyMsRatio"
            >
              复制上年
            </el-button>
          </div>
        </div>

        <!-- MS系数表格 -->
        <air-table
          ref="msRatioTable"
          :columns="msRatioColumns"
          :data="msRatioTableData"
          :loading="msRatioLoading"
          :show-checkbox="false"
          :show-operation="hasPermi('update')"
          :operation-column-width="80"
          :show-export-seq="false"
        >
          <template #operation="{ row }">
            <div class="table-operation flex center">
              <el-button v-if="hasPermi('update')" type="text" @click="handleEditMsRatio(row)">编辑</el-button>
            </div>
          </template>
        </air-table>
      </div>
      <div slot="footer" class="air-modal-footer flex jend acenter">
        <el-button type="text" class="text-button-cancel" @click="msRatioModal.show = false">
          关闭
        </el-button>
      </div>
    </el-dialog>

    <!-- 添加/编辑MS系数内层弹窗（如果需要的话） -->
    <el-dialog
      class="air-modal"
      :title="msRatioForm.id ? '编辑MS系数' : '添加MS系数'"
      :visible.sync="showInnerMsRatioModal"
      :close-on-click-modal="false"
      width="500px"
      append-to-body
      v-dialog-drag
    >
      <div class="air-modal-body flex vertical">
        <el-form
          ref="msRatioForm"
          class="air-form"
          :model="msRatioForm"
          :rules="msRatioRules"
          style="margin-top: 20px"
        >
          <el-col :span="24">
            <el-form-item label="年度" prop="year">
              <el-date-picker
                v-model="msRatioForm.year"
                type="year" :disabled="msRatioForm.id"
                value-format="yyyy"
                placeholder="请选择年度"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="绩效结果（PSC）类型" prop="pscType">
              <el-select
                v-model="msRatioForm.pscType"
                placeholder="请选择绩效结果类型"
                style="width: 100%" :disabled="msRatioForm.id"
              >
                <el-option v-for="item in dictData.pscTypeList" :key="item.id" :value="item.id" :label="item.text"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="MS系数" prop="msRatio">
              <el-input-number
                v-model="msRatioForm.msRatio"
                :min="0"
                :max="10"
                :precision="2"
                :step="0.1"
                style="width: 100%"
                placeholder="请输入MS系数"
              />
            </el-form-item>
          </el-col>
        </el-form>
      </div>
      <div slot="footer" class="air-modal-footer flex jend acenter">
        <el-button type="text" class="text-button-cancel" @click="showInnerMsRatioModal = false">
          取消
        </el-button>
        <el-button :loading="submitLoading" type="primary" @click="submitMsRatioForm">
          保存
        </el-button>
      </div>
    </el-dialog>
    <air-confirm
      :show.sync="confirmShow"
      :title="confirmTitle"
      :content="confirmContent"
      :confirm-function="confirmFunction"
    ></air-confirm>
  </div>
</template>

<script>
import store from '../../store'
import { listData, listColumns, addEmp, updateEmp, deleteEmp, getProfile, addMetasharesPeriod,
  updateMetasharesPeriod, updateMetasharesPercent, updateGoliathPercent, addPscRatingTitle,
  updatePscRatingTitle, queryOrgTreeSelect, listRights, downloadTmpExcel, exportData,
  revokeEmployeeLevel, revokeEmployeeBaseSalary, selectLetterTemp, updateLetterTemp,
  downloadLetter, selectDisabledMetashars, reCalculationMetashares,deleteElementsByEmps,
  getMsRatioList, updateMsRatio, addMsRatio, copyLastYearDatas, updateEmpLevelOrSalary,
  getRefresherCol
} from '@/api/nbqx/index'
import { downloadFile } from '@/util/util'
import {base64Encode, base64Decode} from '@/util/endecode.js'
import { validatenull, validatenumord } from '@/util/validate';

export default {
  name: 'SalaryFile',
  data() {
    let validateFloat = (rule,value,callback)=>{
      if(value){
        if (validatenumord(value,2)) {
          callback(new Error("请输入正确的金额"));
        } else {
          callback();
        }
      }else {
        callback();
      }
    };
    return {
      cusId: '',
      permissionList: [],
      dictData: {
        pscTypeList: [
          { id: 'RE', text: 'RE' },
          { id: 'GE', text: 'GE' },
          { id: 'EE', text: 'EE' },
          { id: 'ME', text: 'ME' },
          { id: 'NI', text: 'NI' },
          { id: 'FE', text: 'FE' },
        ],
      },
      orgTree: [],
      deptTree: [],
      dept2Tree: [],
      dept3List: [],
      dept4List: [],
      filterColumns: ['a0010001', 'a0010002', 'a0010005', 'a0300701', 'a0300702', 'a0300703', 'a0300758','a0300752','a0300706','a0300754','a0300755','a0300756','a0300757','a0300707','a0300708',
        'a0300753','a0300710','a0300777','a0300705','a0300709','a0300713','a0300760','a0300761','a0300712','a0300762','a0300715','a0300716','a0300718','a0300722','a0300764','a0300729','a0300732','a0300733',
        'a0300735','a0300736','a0300737','a0300738','a0300765','a0300766','a0300767','a0300768','a0300769','a0300770','a0300771','a0300772','a0300773','a0300774','a0300775','a0300776','a0300751','a0300778',
        'a0300779','a0300780','a0300781','a0300782','a0300783'],
      ignoreColumns: ['a0010011', 'a0300704', 'a0300717', 'a0300731', 'a0300734'],
      moneyColumns: ['a0300711','a0300709', 'a0300713', 'a0300712', 'a0300715', 'a0300716', 'a0300722', 'a0300729', 'a0300732', 'a0300733', 'a0300735', 'a0300736', 'a0300737','a0300765','a0300766','a0300768','a0300769','a0300771','a0300772','a0300773','a0300774','a0300775','a0300776', 'a0300751','a0300779','a0300780','a0300781','a0300786','a0300797'],
      refresherColumns: [],
      pscRatingColumns: [],
      wideColumns: ['a0300729','a0300733','a0300778'],
      dict: {},
      year: '',
      month: 4,
      tabs: [
        {
          label: '在职员工',
          format: '在职员工 ({0})',
          value: '在职',
          data: []
        },
        {
          label: '离职员工',
          format: '离职员工 ({0})',
          value: '离职',
          data: []
        }
      ],
      activeTab: '在职',
      search: '',
      // 遮罩层
      loading: true,
      // 选中数据
      checkedList: [],
      // 表格数据
      columns: [],
      exportColumns: [],
      tableData: [],
      queryParams: {
        orgIds: []
      },
      showExportSeq: true,
      // 表单参数
      form: {},
      // 导入参数
      upload: {
        // 是否显示弹出层
        show: false,
        // 弹出层标题
        title: '',
        // 是否禁用上传
        isUploading: false,
        // 设置上传的请求头部
        headers: { Authorization: `Bearer ${store.getters.accessToken}` },
        data: {},
        // 上传的地址
        url: ''
      },
      uploadUrl: '/api/sys/metashares/',
      submitLoading: false,
      confirmShow: false,
      confirmTitle: '',
      confirmContent: '',
      confirmFunction: undefined,
      deleteElementEmps: [],
      deleteElementsData: [],
      deleteElementsDataTmp: [
        {title: 'PNL 类型', field: 'A0300782'},
        {title: 'PNL 系数', field: 'A0300797'},
        {title: '晋升后职级', field: 'A0300754'},
        {title: '调薪后月基本工资', field: 'A0300709'},
        {title: '1-2月基本工资', field: 'A0300784'},
        {title: '3-6月基本工资', field: 'A0300785'},
        {title: '是否增加上一年度PSC未计算奖金', field: 'A0300753'},
        {title: '额外奖金', field: 'A0300713'},
        {title: '入职第一年是否保证1元收益', field: 'A0300764'},
        {title: '是否递延', field: 'A0300770'}
      ],
      deleteElementsChecked: [],
      deleteElementShow: false,
      deleteElementConfirmContext: '',
      count: 3,
      empModal: {
        title: '',
        show: false,
        edit: false
      },
      empForm: {},
      empRules: {
        a0010001: [
          { required: true, message: '该项不能为空', trigger: 'blur' }
        ],
        a0010002: [
          { required: true, message: '该项不能为空', trigger: 'blur' }
        ],
        a0010005: [
          { required: true, message: '该项不能为空', trigger: 'blur' }
        ],
        a0300701: [
          { required: true, message: '该项不能为空', trigger: 'change' }
        ],
        a0010039: [
          { required: true, message: '该项不能为空', trigger: 'change' }
        ],
        a0300706: [
          { required: true, message: '该项不能为空', trigger: 'change' }
        ],
        a0300710: [
          { required: true, validator: validateFloat, trigger: 'change' }
        ],
        a0300705: [
          { required: true, validator: validateFloat, trigger: 'change' }
        ],
        a0300761: [
          { required: true, validator: validateFloat, trigger: 'change' }
        ],
        a0300712: [
          { required: true, validator: validateFloat, trigger: 'change' }
        ],
        a0300722: [
          { required: true, validator: validateFloat, trigger: 'change' }
        ],
        a0300729: [
          { required: true, validator: validateFloat, trigger: 'change' }
        ],
        a0300733: [
          { required: true, validator: validateFloat, trigger: 'change' }
        ],
        a0300735: [
          { required: true, validator: validateFloat, trigger: 'change' }
        ],
        a0300736: [
          { required: true, validator: validateFloat, trigger: 'change' }
        ],
        a0300737: [
          { required: true, validator: validateFloat, trigger: 'change' }
        ],
        a0300738: [
          { required: true, validator: validateFloat, trigger: 'change' }
        ],
        a0300765: [
          { required: true, validator: validateFloat, trigger: 'change' }
        ],
        a0300766: [
          { required: true, validator: validateFloat, trigger: 'change' }
        ],
        a0300768: [
          { required: true, validator: validateFloat, trigger: 'change' }
        ],
        a0300769: [
          { required: true, validator: validateFloat, trigger: 'change' }
        ],
        a0300771: [
          { required: true, validator: validateFloat, trigger: 'change' }
        ],
        a0300772: [
          { required: true, validator: validateFloat, trigger: 'change' }
        ],
        a0300773: [
          { required: true, validator: validateFloat, trigger: 'change' }
        ],
        a0300774: [
          { required: true, validator: validateFloat, trigger: 'change' }
        ],
        a0300775: [
          { required: true, validator: validateFloat, trigger: 'change' }
        ],
        a0300776: [
          { required: true, validator: validateFloat, trigger: 'change' }
        ],
        a0300777: [
          { required: true, validator: validateFloat, trigger: 'change' }
        ],
        a0300751: [
          { required: true, validator: validateFloat, trigger: 'change' }
        ],
        a0300780: [
          { required: true, validator: validateFloat, trigger: 'change' }
        ],
        a0300781: [
          { required: true, validator: validateFloat, trigger: 'change' }
        ],
      },
      profileModalShow: false,
      profile: {
        level: [{}],
        rating: [{}],
        employee: [{}],
        basySalary: [{}]
      },
      metasharesModal: {
        title: '',
        show: false
      },
      metasharesForm: {
        itemId: undefined,
        itemMin: '',
        itemMax: '',
        itemName: '',
        period: '',
        isMsValue: '10020002',
        effectiveDate: ''
      },
      metasharesRules: {
        itemMin: [
          { required: true, message: '起始日期不能为空', trigger: 'blur' }
        ],
        itemMax: [
          { required: true, message: '结束日期不能为空', trigger: 'blur' }
        ],
        effectiveDate: [
          { required: true, message: 'effective date不能为空', trigger: 'blur' }
        ],
        isMsValue: [
          { required: true, message: '是否为MS价值不能为空', trigger: 'change' }
        ],
      },
      percentModal: {
        title: '',
        show: false
      },
      percentForm: {
        itemId: undefined,
        label: '',
        percent: undefined
      },
      percentRules: {
        percent: [
          { required: true, message: '数字不能为空', trigger: 'blur' }
        ],
      },
      pscRatingModal: {
        title: '',
        show: false
      },
      pscRatingForm: {
        itemId: undefined,
        year: '',
        itemName: ''
      },
      pscRatingRules: {
        year: [
          { required: true, message: '请选择年份', trigger: 'blur' }
        ],
        itemName: [
          { required: true, message: '请输入名称', trigger: 'blur' }
        ]
      },
      letterModal: {
        show: false
      },
      letterForm: {
        id:undefined,
        schedule:'middle',
        name:undefined,
        letterId:undefined,
        title: undefined,
        content: undefined,
        isNull: undefined,
        sign: undefined,
        signDate: undefined,
        attr: undefined
      },
      letterRules: {
        title: [
          { required: true, message: '标题不能为空', trigger: 'blur' }
        ],
        signDate: [
          { required: true, message: '落款日期不能为空', trigger: 'blur' }
        ],
      },
      // 落款日期相关数据
      signDateType: 'date', // date: 年月日, month: 年月
      // 英文月份配置
      enMonths: [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
      ],
      showSignDatePicker: false,
      letterFieldList: [],
      loadingRating: false,
      ratingModal: {
        show: false
      },
      tableDataRating: [],
      columnsRating: [
        {title: '开始时间', field: 'startTime', minWidth: 120},
        {title: '结束时间', field: 'endTime', minWidth: 120},
        {title: '份额', field: 'metashareValue', minWidth: 80}
      ],
      loadingBonusDetails: false,
      bonusModal: {
        show: false
      },
      tableDataBonusDetails: [],
      columnsBonusDetails: [
        {title: '奖金所属年度', field: 'detailYear', minWidth: 120},
        {title: '发放时间', field: 'detailPayTime', minWidth: 120},
        {title: '待发金额', field: 'detailPayAmount', minWidth: 80}
      ],
      cursorIndex: {
        title: 0,
        content: 0,
        sign: 0,
        attr: 0
      },
      cursorNow: undefined,
      // MS系数弹窗相关数据
      msRatioModal: {
        title: 'MS系数管理',
        show: false
      },
      msRatioForm: {
        year: '',
        pscType: '',
        msRatio: '',
        id: undefined
      },
      msRatioRules: {
        year: [
          { required: true, message: '请选择年度', trigger: 'change' }
        ],
        pscType: [
          { required: true, message: '请选择绩效结果类型', trigger: 'change' }
        ],
        msRatio: [
          { required: true, message: '请输入MS系数', trigger: 'blur' },
          { validator: validateFloat, trigger: 'change' }
        ]
      },
      msRatioTableData: [],
      msRatioColumns: [
        { title: '年度', field: 'year', minWidth: 100 },
        { title: '绩效结果类型', field: 'pscType', minWidth: 150 },
        { title: 'MS系数', field: 'msRatio', minWidth: 120, money: true },
        { title: '创建时间', field: 'createTime', minWidth: 180 },
        { title: '创建人', field: 'creater', minWidth: 120 },
      ],
      msRatioQueryParams: {
        year: this.$day().format('YYYY') // 默认设置为今年
      },
      msRatioLoading: false,
      showInnerMsRatioModal: false,
      promotionModal: {
        show: false,
        title: '晋升与调薪'
      },
      promotionForm: {
        year: '',
        actionType: 'both' // both: 两者都更新, promotion: 仅晋升, salary: 仅调薪
      },
      promotionRules: {
        year: [
          { required: true, message: '请选择年度', trigger: 'change' }
        ],
        actionType: [
          { required: true, message: '请选择操作类型', trigger: 'change' }
        ]
      },
    }
  },
  computed: {
    metaStartPickerOptions() {
      const vm = this
      return {
        disabledDate(time) {
          if (vm.metasharesForm.itemMax) {
            return vm.$day(time).isAfter(vm.metasharesForm.itemMax)
          }
        }
      }
    },
    metaEndPickerOptions() {
      const vm = this
      return {
        disabledDate(time) {
          if (vm.metasharesForm.itemMin) {
            return vm.$day(time).isBefore(vm.metasharesForm.itemMin)
          }
        }
      }
    },
    // effectiveDate 日期选择范围，为表格上方年度的1月1日至12月31日
    effectiveDatePickerOptions() {
      const vm = this
      return {
        disabledDate(time) {
          const year = vm.year;
          const startDate = `${ year }-01-01`;
          const endDate = `${ year }-12-31`;
          return vm.$day(time).isBefore(startDate) || vm.$day(time).isAfter(endDate);
        }
      }
    }
  },
  async created() {
    // 创建一次 dayjs 实例以提高性能
    const currentDate = this.$day();
    let currentYear = parseInt(currentDate.format('YYYY'), 10); // 使用 let 因为我们会修改这个值
    const currentMonth = parseInt(currentDate.format('MM'), 10);

    if (currentMonth === 1 || currentMonth === 2 || currentMonth === 3) {
      currentYear -= 1;
      this.month = currentMonth
    }
    this.year = currentYear.toString();
    await this.getPermi()
    if (this.$route.query.hireStatus) {
      this.activeTab = this.$route.query.hireStatus
    }
    this.cusId = sessionStorage.getItem('cusId');
    const isSameYear = this.$day().isSame(this.year, 'year');
    this.metasharesForm.effectiveDate = isSameYear ? this.$day().format('YYYY-MM-DD') : `${this.year}-12-31`;
    this.getOrgTree()
    this.getData()
    this.getRefresherCol()
  },
  methods: {
    handleDateTypeChange() {
      // 切换类型时清空已选择的日期
      this.letterForm.signDate = '';
    },
    // 显示MS系数管理弹窗
    async showMsRatioModal() {
      this.msRatioModal.show = true
      await this.getMsRatioData()
    },

    // 获取MS系数数据
    async getMsRatioData() {
      this.msRatioLoading = true
      try {
        // 这里调用后端API获取MS系数数据
        const res = await getMsRatioList(this.msRatioQueryParams)
        this.msRatioTableData = res.data.data
      } catch (error) {
        console.error('获取MS系数数据失败:', error)
      } finally {
        this.msRatioLoading = false
      }
    },

    // 添加MS系数
    handleAddMsRatio() {
      this.msRatioForm = {
        year: this.year, // 默认使用当前选中的年度
        pscType: '',
        msRatio: '',
        id: undefined
      }
      this.resetForm('msRatioForm');
      this.showInnerMsRatioModal=true;
    },

    handleCopyMsRatio(){
      if(!this.msRatioQueryParams.year){
        this.$msgError('您未选择年度')
      }
      this.msRatioForm = {
        year: this.msRatioQueryParams.year, // 默认使用当前选中的年度
      }
      let lastYear = this.msRatioQueryParams.year - 1
      this.confirmShow = true
      this.confirmTitle = '配置复制'
      this.confirmContent = `确认把${lastYear}年的配置复制到${this.msRatioQueryParams.year}年吗? `
      this.confirmFunction = () => {
        copyLastYearDatas(this.msRatioForm).then(() => {
          this.getMsRatioData()
          this.$msgSuccess('复制成功')
        })
      }
    },

    // 编辑MS系数
    handleEditMsRatio(row) {
      this.msRatioForm = {
        ...row,
        id: row.id
      }
      // 这里需要打开一个内层弹窗来编辑
      this.showInnerMsRatioModal=true;
    },

    // 提交MS系数表单
    submitMsRatioForm() {
      this.$refs.msRatioForm.validate(valid => {
        if (valid) {
          this.submitLoading = true
          // 调用添加或更新API
          const api = this.msRatioForm.id ? updateMsRatio : addMsRatio
          api(this.msRatioForm).then(data => {
            this.getMsRatioData()
            this.resetForm('msRatioForm')
            if(data.data.code == 0){
              this.$msgSuccess(this.msRatioForm.id ? '更新成功' : '添加成功')
            }
            this.submitLoading = false
            this.showInnerMsRatioModal = false
          }).catch(() => this.submitLoading = false)
            .finally(() => this.submitLoading = false)
        }
      })
    },

    // 年度筛选变化
    handleMsRatioYearChange() {
      this.getMsRatioData()
    },
    async getPermi() {
      const res = await listRights()
      this.permissionList = res.data.map(item => item.buttonCode)
    },
    async getRefresherCol(){
      const { orgIds }= this.queryParams;
      const params = {
        year: this.year,
        effectiveDate:this.metasharesForm.effectiveDate,
        ...this.queryParams,
        orgIds: orgIds && orgIds.length ? orgIds : undefined
      }
      let dataRes = await getRefresherCol(params);
      this.deleteElementsData = this.deleteElementsDataTmp;
      dataRes.data.forEach(i => {
        let el = {title: i.title, field: i.field};
        this.deleteElementsData.push(el);
      });
    },
    async getData(reflesh) {
      this.loading = true
      this.columns = []
      this.exportColumns = []
      this.refresherColumns = []
      this.pscRatingColumns = []
      this.tableData = []
      this.checkedList = []
      const { orgIds }= this.queryParams;
      const params = {
          year: this.year,
          reflesh: reflesh,
          effectiveDate:this.metasharesForm.effectiveDate,
          ...this.queryParams,
          orgIds: orgIds && orgIds.length ? orgIds : undefined
      }
      let dataRes = await listData(params)
      this.$handleEmpHireTabs(this.tabs, dataRes.data)
      this.changeTab()
      let columnRes = await listColumns({ year: this.year })
      this.columns = this.formatColumns(columnRes.data)
      this.loading = false
    },
    // 只获取表格数据
    async getTableData(reflesh) {
      this.loading = true;
      const { orgIds }= this.queryParams;
      const params = {
        year: this.year,
        reflesh: reflesh,
        ...this.queryParams,
        orgIds: orgIds && orgIds.length ? orgIds : undefined,
        effectiveDate: this.metasharesForm.effectiveDate
      }
      try {
        let dataRes = await listData(params)
        this.$handleEmpHireTabs(this.tabs, dataRes.data)
        this.changeTab();
      } catch (error) {
        console.error('获取MS系数数据失败:', error)
      } finally {
        this.loading = false;
      }
      this.loading = false;
    },
    handleTableData(data) {
      data.forEach(item => {
        item.salaryValueList.forEach(salary => {
          item[salary.fieldId] = salary.value
        })
      })
    },
    changeTab() {
      this.handleSearch()
    },
    check({ records }) {
      this.checkedList = records
    },
    handleSearch() {
      this.checkedList = []
      this.$refs.airTable.clearCheckbox()
      let temp = this.activeTab === '在职' ? this.tabs[0].data : this.tabs[1].data
      this.tableData = temp.filter(item => {
        return (item.a0010001 && item.a0010001.includes(this.search)) || (item.a0010002 && item.a0010002.includes(this.search))
      })
    },
    clickHeaderIcon(e) {
      this.submitLoading = false;
      if (e.title === ('Refresher') || (e.infoGroup != undefined && e.infoGroup.includes('Refresher'))) {
        if (e.headerCustom === 'add') {
          this.metasharesModal.title = '添加Metashares'
          this.metasharesForm.itemId = undefined
          this.metasharesForm.itemName = ''
          this.metasharesForm.itemMin = ''
          this.metasharesForm.itemMax = ''
          this.metasharesForm.isMsValue = '10020002'
        } else {
          this.metasharesModal.title = '编辑Metashares'
          this.metasharesForm.itemId = e.itemId
          this.metasharesForm.itemName = e.itemName
          this.metasharesForm.itemMin = e.itemMin
          this.metasharesForm.itemMax = e.itemMax
          this.metasharesForm.isMsValue = e.isMsValue
          if (validatenull(this.metasharesForm.effectiveDate)) {
            const isSameYear = this.$day().isSame(this.year, 'year');
            this.metasharesForm.effectiveDate = isSameYear ? new Date() : `${ this.year }-12-31`;
          }
        }
        this.metasharesForm.period = ''
        this.metasharesModal.show = true
        } else if (e.title === ('当期 PSC Rating 记录') || (e.infoGroup != undefined && e.infoGroup.includes('当期 PSC Rating 记录'))) {
        if (e.headerCustom === 'add') {
          this.pscRatingModal.title = '添加 PSC Rating';
        } else {
          this.pscRatingModal.title = '编辑 PSC Rating';
          this.pscRatingForm.itemId = e.itemId;
          this.pscRatingForm.year = e.itemMin;
          this.pscRatingForm.itemName = e.itemName;
        }
        this.pscRatingModal.show = true
      } else {
        this.percentForm.itemId = e.itemId
        if (e.itemId === 'a0300729') {
          this.percentModal.title = '编辑Metashares预测'
          this.percentForm.percent=e.itemMin
          this.percentForm.label = `${this.year}年Metashares预测收益率为`
        }
        if (e.itemId === 'a0300733') {
          this.percentModal.title = '编辑Goliath预测'
          this.percentForm.percent=e.itemMin
          this.percentForm.label = `${this.year}年Goliath预测收益率为`
        }
        this.percentModal.show = true
      }
    },
    changeMetaPeriod() {
      this.metasharesForm.itemMax = this.$day(this.metasharesForm.itemMin).add(this.metasharesForm.period, 'M').subtract(1, 'd').format('YYYY-MM-DD')
    },
    submitMetasharesForm() {
      this.$refs.metasharesForm.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.metasharesForm.itemId === 'a0300722') {
            this.metasharesModal.show = false;
            this.submitLoading = false;
            this.getTableData();
          } else {
            if (this.metasharesForm.itemId !== undefined) {
              updateMetasharesPeriod(this.metasharesForm).then(data => {
                this.$msgSuccess('编辑成功')
                this.metasharesModal.show = false
                this.getData()
                this.submitLoading = false
              }).catch(() => this.submitLoading = false)
            } else {
              addMetasharesPeriod(this.metasharesForm).then(data => {
                this.$msgSuccess('添加成功')
                this.metasharesModal.show = false
                this.getData()
                this.submitLoading = false
              }).catch(() => this.submitLoading = false)
            }
          }
        }
      })
    },
    metasharesFormClosed() {
      if (this.metasharesForm.itemId !== 'a0300722') {
        this.resetForm('metasharesForm');
      }
    },
    pscRatingFormClosed() {
      this.pscRatingForm = {
        itemId: undefined,
        year: '',
        itemName: ''
      };
      this.resetForm('pscRatingForm');
    },
    submitPercentForm() {
      this.$refs.percentForm.validate(valid => {
        if (valid) {
          this.submitLoading = true
          this.percentForm.year = this.year
          let itemId = this.percentForm.itemId === 'a0300729' ? 'a0300731' : 'a0300734'
          const api = this.percentForm.itemId === 'a0300729' ? updateMetasharesPercent : updateGoliathPercent
          api(this.percentForm).then(data => {
            this.$msgSuccess('编辑成功')
            this.percentModal.show = false
            this.getData()
          }).catch(() => this.submitLoading = false)
        }
      })
    },
    // 当期 PSC Rating 名称 添加/修改
    submitPscRatingForm() {
      this.$refs.pscRatingForm.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.pscRatingForm.itemId !== undefined) {
            updatePscRatingTitle(this.pscRatingForm).then(data => {
              this.$msgSuccess('编辑成功')
              this.pscRatingModal.show = false
              this.getData()
              this.submitLoading = false
            }).catch(() => this.submitLoading = false)
          } else {
            addPscRatingTitle(this.pscRatingForm).then(data => {
              this.$msgSuccess('添加成功')
              this.pscRatingModal.show = false
              this.getData()
              this.submitLoading = false
            }).catch(() => this.submitLoading = false)
          }
        }
      })
    },
    getOrgTree() {
      queryOrgTreeSelect(this.cusId).then(res => {
        this.orgTree = res.data[0].children
      })
    },
    changeLetter(val){
      const selectLetterIndex = this.letterForm.letterId.findIndex(item=>{
        return item.id === val;
      });
      const selectLetter = this.letterForm.letterId[selectLetterIndex];
      this.letterFieldList = JSON.parse(base64Decode(selectLetter.letterSelectField))
      this.letterForm.name=selectLetter.letterName
      this.letterForm.title=base64Decode(selectLetter.letterTitle)
      this.letterForm.content=base64Decode(selectLetter.letterContent)
      this.letterForm.isNull=selectLetter.letterIsNull
      this.letterForm.sign=base64Decode(selectLetter.letterSign)
      this.letterForm.attr=base64Decode(selectLetter.letterAttr)
    },
    changeOrg() {
      this.$set(this.empForm, 'a0300702', undefined)
      this.$set(this.empForm, 'a0300703', undefined)
      this.$set(this.empForm, 'a0300758', undefined)
      const org = this.orgTree.find('orgName', this.empForm.a0300701)
      this.deptTree = org.children
      this.dept2Tree = []
      this.dept3Tree = []
    },
    changeDept() {
      this.$set(this.empForm, 'a0300703', undefined)
      this.$set(this.empForm, 'a0300758', undefined)
      const dept = this.deptTree.find('orgName', this.empForm.a0300702)
      this.dept2Tree = dept.children
      this.dept3Tree = []
    },
    change2Dept() {
      this.$set(this.empForm, 'a0300758', undefined)
      const dept = this.dept2Tree.find('orgName', this.empForm.a0300703)
      this.dept3Tree = dept.children
    },
    showEmpModal(row) {
      // this.reset()
      this.empModal.edit = !!row
      this.empModal.title = row ? '编辑员工' : '添加员工'
      if (row) {
        this.empForm = this.$clone(row)
      }
      this.empModal.show = true
    },
    empFormClosed() {
      this.reset();
    },
    submitEmpForm() {
      this.$refs.empForm.validate(valid => {
        if (valid) {
          this.submitLoading = true
          this.empForm.year = this.year
          if (!this.empModal.edit) {
            // 如果是新增，则阶段有效期起始日期为入职日期
            this.empForm.a0300717 = this.empForm.a0010039
          }
          // 格式化金额字符串
          const refresherColumnIds = this.refresherColumns.map(item => item.itemId)
          for (let key of Object.keys(this.empForm)) {
            if (this.moneyColumns.includes(key) ) {
              if(this.empForm[key]!=undefined&&this.empForm[key]!=''){
                this.empForm[key] = this.$formatInputMoney(this.empForm[key])
              }
            }
            if (this.filterColumns.includes(key) ) {
              if(this.empForm[key]===undefined){
                this.empForm[key] = null
              }
            }
          }
          const api = this.empModal.edit ? updateEmp : addEmp
          api(this.empForm).then(data => {
            this.$msgSuccess('保存成功')
            this.empModal.show = false
            this.getData()
            this.resetForm('empForm')
          }).catch(() => this.submitLoading = false)
        }
      })
    },
    // 表单重置
    reset() {
      this.empForm = {
        a0010001: undefined,
        a0010002: undefined,
        a0010005: undefined,
        a0300701: undefined,
        a0300702: undefined,
        a0300703: undefined,
        a0300758: undefined,
        a0010039: undefined,
        a0010040: undefined,
        a0300706: undefined,
        a0300711: undefined,
        a0300718: undefined,
        a0300752: undefined,
        a0300754: undefined,
        a0300755: undefined,
        a0300756: undefined,
        a0300757: undefined,
        a0300707: undefined,
        a0300708: undefined,
        a0300753: undefined,
        a0300710: undefined,
        a0300705: undefined,
        a0300709: undefined,
        a0300713: undefined,
        A0300760: undefined,A0300761: undefined,A0300712: undefined,A0300762: undefined,A0300715: undefined,A0300716: undefined,
        A0300722: undefined,A0300764: undefined,A0300729: undefined,A0300732: undefined,A0300733: undefined,A0300735: undefined,
        A0300736: undefined,A0300737: undefined,A0300738: undefined,A0300765: undefined,A0300766: undefined,A0300767: undefined,
        A0300768: undefined,A0300769: undefined,A0300770: undefined,A0300771: undefined,A0300772: undefined,A0300773: undefined,
        A0300774: undefined,A0300775: undefined,A0300776: undefined,A0300751: undefined,A0300777: undefined,A0300778: undefined,
        A0300779: undefined,
        A0300780: undefined,A0300781: undefined,A0300782: undefined,A0300783: undefined,A0300784: undefined,A0300785: undefined,
        A0300786: undefined,A0300797: undefined
      }
      this.deptTree = []
      this.dept2Tree = []
      this.dept3Tree = []
      this.resetForm('empForm')
      this.submitLoading = false
    },
    // 清空表单
    resetForm(formName) {
      if (this.$refs[formName] !== undefined) {
        this.$refs[formName].resetFields();
      }
    },
    async showEmpProfile(row) {
      const res = await getProfile({ id: row.id })
      this.profile = res.data
      this.profileModalShow = true
    },
    revokeLevel(item) {
      const data = {...item, ...this.profile.employee[0]}
      this.confirmShow = true
      this.confirmTitle = '提示'
      this.confirmContent = `确认撤销 ${item.a0300706} 吗?`
      this.confirmFunction = () => {
        revokeEmployeeLevel(data).then(() => {
          this.getData()
          this.showEmpProfile(data)
          this.$msgSuccess('撤销成功')
        })
      }
    },
    revokeSalary(item) {
      const data = {...item, ...this.profile.employee[0]}
      this.confirmShow = true
      this.confirmTitle = '提示'
      this.confirmContent = `确认撤销 ${this.$formatMoney(item.a0300711)} 吗?`
      this.confirmFunction = () => {
        revokeEmployeeBaseSalary(data).then(() => {
          this.getData()
          this.showEmpProfile(data)
          this.$msgSuccess('撤销成功')
        })
      }
    },
    // 删除按钮操作
    handleDelete(row) {
      const list = row.id ? [{ a0010001: row.a0010001, a0010002: row.a0010002 }] : this.checkedList.map(item => {
        return { a0010001: item.a0010001, a0010002: item.a0010002 }
      })
      this.confirmShow = true
      this.confirmTitle = '删除员工'
      this.confirmContent = `确认删除员工${row.id ? `「${row.a0010002}」` : `${this.checkedList.map(item => `「${item.a0010002}」`).join('、')}`}?`
      this.confirmFunction = () => {
        deleteEmp({
          list,
          year: this.year
        }).then(() => {
          this.getData()
          this.$msgSuccess('删除成功')
        })
      }
    },

    batchUpdateZjAndXz(row) {
      if (this.checkedList.length === 0) {
        this.$msgError('请先选择员工');
        return;
      }

      // 设置默认年份为当前选择的年份
      this.promotionForm.year = this.year;
      this.promotionForm.actionType = 'both';
      this.promotionModal.show = true;

      // 清除表单验证
      if (this.$refs.promotionFormRef) {
        this.$nextTick(() => {
          this.$refs.promotionFormRef.clearValidate();
        });
      }
    },

    // 添加 handlePromotionConfirm 方法
    handlePromotionConfirm() {
      this.$refs.promotionFormRef.validate(valid => {
        if (valid) {
          this.confirmShow = true;
          this.confirmTitle = '晋升与调薪确认';

          // 根据操作类型显示不同的确认信息
          let actionText = '';
          switch (this.promotionForm.actionType) {
            case 'both':
              actionText = '晋升和调薪';
              break;
            case 'promotion':
              actionText = '晋升';
              break;
            case 'salary':
              actionText = '调薪';
              break;
          }

          this.confirmContent = `是否确认把选中员工${this.promotionForm.year}年度的${actionText}数据更新到${this.year}年度？（注：晋升后职级或调薪后薪资不为空时才更新）`;

          this.confirmFunction = () => {
            this.submitPromotionUpdate();
          };
        }
      });
    },

    // 添加 submitPromotionUpdate 方法
    async submitPromotionUpdate() {
      try {
        this.submitLoading = true;
        const list = this.checkedList.map(item => ({
          a0010001: item.a0010001,
          a0010002: item.a0010002
        }));

        await updateEmpLevelOrSalary({
          list,
          year: this.promotionForm.year,
          curYear: this.year,
          actionType: this.promotionForm.actionType // 传递操作类型
        });
        this.$msgSuccess('更新成功');
        this.promotionModal.show = false;
        this.getData(); // 刷新数据
      } catch (error) {
        console.error('更新失败:', error);
        this.$msgError('更新失败');
      } finally {
        this.submitLoading = false;
      }
    },

    handleDeleteElement(row){
      this.deleteElementShow=true;
      const list = row.subId ? [{ subId: row.subId,a0010001: row.a0010001, a0010002: row.a0010002 }] : this.checkedList.map(item => {
        return { subId: item.subId,a0010001: item.a0010001, a0010002: item.a0010002 }
      })
      this.deleteElementEmps = list
      const count = this.count
      const deleteElementEmpsClip = list.slice(0, count)
      const deleteElementEmpsClipContext = deleteElementEmpsClip.map(item => `「${item.a0010002}」`).join('、')
      this.deleteElementConfirmContext = `确认要删除员工${ deleteElementEmpsClipContext }${ list.length > count ? '...' : '' } 的如下内容?`
    },
    async showLetterModal() {
      this.submitLoading=false
      const res = await selectLetterTemp()
      const data = res.data.data
      this.letterForm.letterId=data
      const firstLetter = data[0]
      this.letterFieldList = JSON.parse(base64Decode(firstLetter.letterSelectField))
      this.letterForm.name=firstLetter.letterName
      this.letterForm.id=firstLetter.id
      this.letterForm.title=base64Decode(firstLetter.letterTitle)
      this.letterForm.content=base64Decode(firstLetter.letterContent)
      this.letterForm.isNull=firstLetter.letterIsNull
      this.letterForm.sign=base64Decode(firstLetter.letterSign)
      this.letterForm.attr=base64Decode(firstLetter.letterAttr)
      this.letterModal.show = true
    },
    async submitLetterFormOnly(){
      this.submitLoading = true
      let data = {}
      data.id=this.letterForm.id;
      data.name=this.letterForm.name;
      data.title=base64Encode(this.letterForm.title);
      data.content=base64Encode(this.letterForm.content);
      data.isNull=this.letterForm.isNull;
      data.sign=base64Encode(this.letterForm.sign);
      data.attr=base64Encode(this.letterForm.attr);
      data.cusId = sessionStorage.getItem('cusId')
      await updateLetterTemp(data)
      this.submitLoading = false
      this.$msgSuccess('保存成功')
    },
    async submitLetterForm() {
      if(this.letterForm.signDate == '' || this.letterForm.signDate == undefined){
        this.$msgError('请选择落款日期')
        return
      }
      this.submitLoading = true
      const dataList = this.checkedList && this.checkedList.length ? this.checkedList : this.tableData
      let errMsg='';
      const subIds=dataList.map(item => {
        if(item.subId){
        return item.subId
        }else{
          errMsg=errMsg+item.a0010002+";"
          return '-1'
        }
      })
      // 下载letter
      let downloadData = {
        year: this.year,
        subIds: subIds,
        id:this.letterForm.id,
        schedule: this.letterForm.schedule,
        signDate: this.letterForm.signDate,
      }
      await downloadLetter(downloadData).then(res => {
        downloadFile(res)
      })
      this.submitLoading = false
      if(errMsg!=''){
        this.$msgSuccess('Letter已成功生成,但是部分人员无本年绩效，无法生成。'+errMsg)
      }else{
        this.$msgSuccess('Letter已成功生成')
      }

      this.letterModal.show = false
    },
    blurLetterInput(key, e) {
      this.cursorIndex[key] = e.srcElement.selectionStart
      this.cursorNow = key
    },
    addLetterField(item) {
      this.insertVal(`#${item.itemName}#`)
    },
    insertVal(val) {
      let content = this.letterForm[this.cursorNow]
      if (content) {
        let index = this.cursorIndex[this.cursorNow]
        let name = content
        content = name.slice(0, index) + val + name.slice(index)
        this.cursorIndex[this.cursorNow] = index + val.length
      } else {
        content = val
        this.cursorIndex[this.cursorNow] = val.length
      }
      this.letterForm[this.cursorNow] = content
      // this.$refs[`${this.cursorNow}Input`].focus()
    },
    // 导出按钮操作
    handleExport() {
      const dataList = this.checkedList && this.checkedList.length ? this.checkedList : this.tableData
      exportData({
        headerList: this.exportColumns,
        year:this.year,
        dataList
      }).then(res => {
        downloadFile(res)
      })
    },
    /** 导入按钮操作 */
    handleImport(type) {
      this.upload.isUploading = false
      this.submitLoading = false
      this.upload.title = type === 'batchInsert' ? '批量添加' : '批量编辑'
      this.upload.data = {
        year: this.year
      }
      this.upload.url = this.uploadUrl + type
      this.upload.show = true
    },
    /** 下载模板操作 */
    importTemplate() {
      downloadTmpExcel(this.year).then(res => {
        downloadFile(res)
      })
    },
    // 文件上传中处理
    handleFileUploadProgress(event, file, fileList) {
      this.upload.isUploading = true
    },
    // 文件上传成功处理
    handleFileSuccess(response, file, fileList) {
      this.$refs.upload.clearFiles()
      if (response.code == 0) {
        this.upload.show = false
        this.getData()
      } else {
        this.$msgError(response.msg);
        this.upload.isUploading = false;
        this.submitLoading = false;
      }
    },
    // 提交上传文件
    submitFileForm() {
      if (!this.$refs.upload.uploadFiles.length) {
        this.$msgError('您未选择任何文件')
        return
      }
      this.submitLoading = true
      this.$refs.upload.submit()
    },
    cancelUpload() {
      this.$refs.upload.clearFiles()
      this.upload.show = false
    },
    // 将表头列表转换为三级表头
    formatColumns(columns) {
      let result = []
      for (let column of columns) {
        // 添加字典
        if (column.codeSetItems && column.codeSetItems.length) {
          this.dict[column.itemId] = column.codeSetItems.map(item => {
            return {
              label: item.codeItemName,
              value: item.codeItemId
            }
          })
        }
        if (this.ignoreColumns.includes(column.itemId)) {
          continue
        }
        this.exportColumns.push(this.$clone(column))
        column.title = column.itemName
        column.field = column.itemId
        column.minWidth = '120'
        column.align = 'center'
        if (this.wideColumns.includes(column.itemId)) {
          column.minWidth = '190'
        }
        // 姓名、本年度失效Metashars份数 可点击
        if (column.itemId === 'a0010002') {
          column.fixed = 'left'
          column.custom = true
        }
        if (column.itemId === 'a0300751') {
          column.custom = true
        }
        if (column.itemId === 'a0300786') {
          column.custom = true
        }
        // if (this.filterColumns.includes(column.itemId)) {
          // column.filters = [{data: {vals: [], sVal: ''}}]
          // column.filterRender = 'FilterContent'
        // }
        if (column.itemProperty === '1') {
          column.headerCustom = 'edit'
          column.minWidth = '280'
          if (column.infoGroup === 'Refresher') {
            this.refresherColumns.push(column)
          }
          if (column.infoGroup === '当期 PSC Rating 记录'){
            this.pscRatingColumns.push(column)
          }
        }
        // effective Metashares
        if (column.itemId === 'a0300722') {
          column.headerCustom = 'edit'
          column.minWidth = '220'
          column.title = `${column.itemName}`;
        }
        if (column.itemId === 'a0300729') {
          column.headerCustom = 'edit'
          column.minWidth = '180'
          column.title = `${column.itemName} ${column.itemMin}`
          column.className = 'cell-color-orange'
        }
        if (column.itemId === 'a0300733') {
          column.headerCustom = 'edit'
          column.minWidth = '200'
          column.title = `${column.itemName} ${column.itemMin}`
          column.className = 'cell-color-orange'
        }
        // 【Package】和【本年度奖金及分红】显示为红色
        if (column.itemId === 'a0300737' || column.itemId === 'a0300769') {
          column.className = 'cell-color-red'
        }
        // 格式化金额字符串
        if (this.moneyColumns.includes(column.field) || column.infoGroup === 'Refresher') {
          column.money = true
        }
        // 个人基本信息列头添加筛选
        if (column.infoGroup === '个人基本信息') {
          if (column.itemId !== 'a0300797'){
            if (column.codeSetItems && column.codeSetItems.length) {
              column.filterType = 'select';
              column.filterOptionProps = {
                value: 'codeItemName',
                label: 'codeItemName'
              };
              column.filterOptions = column.codeSetItems
            } else if (column.itemId === 'a0010039' || column.itemId === 'a0010040Date') {
              column.filterType = 'daterange';
            } else {
              column.filterType = 'input';
            }
          }
        }
        // 第一列
        if (!result.length) {
          if (column.infoGroup) {
            if (column.infoNextGroup) {
              result.push({
                title: column.infoGroup,
                align: 'center',
                isGroup: true,
                children: [{
                  title: column.infoNextGroup,
                  align: 'center',
                  isGroup: true,
                  children: [column]
                }]
              })
            } else {
              result.push({
                title: column.infoGroup,
                align: 'center',
                isGroup: true,
                children: [column]
              })
            }
          } else {
            result.push(column)
          }
          continue
        }
        if (column.infoGroup) {
          let level1Flag = false
          for (let level1 of result) {
            if (level1.title === column.infoGroup) {
              // 如果一级相同，则先匹配二级
              if (column.infoNextGroup) {
                let level2Flag = false
                for (let level2 of level1.children) {
                  if (level2.title === column.infoNextGroup) {
                    // 如果匹配则设置到三级表头
                    level2.children.push(column)
                    level2Flag = true
                    break
                  }
                }
                // 如果二级没有能匹配的，则新增一个二级
                if (!level2Flag) {
                  level1.children.push({
                    title: column.infoNextGroup,
                    align: 'center',
                    isGroup: true,
                    children: [column]
                  })
                }
              } else {
                // 如果没有二级
                level1.children.push(column)
              }
              level1Flag = true
              break
            }
          }
          // 如果一级没有能匹配的，则新增一个一级
          if (!level1Flag) {
            if (column.infoNextGroup) {
              result.push({
                title: column.infoGroup,
                align: 'center',
                isGroup: true,
                children: [{
                  title: column.infoNextGroup,
                  align: 'center',
                  isGroup: true,
                  children: [column]
                }]
              })
            } else {
              let level1 = {
                title: column.infoGroup,
                align: 'center',
                isGroup: true,
                children: [column]
              }
              if (level1.title === 'Refresher' || level1.title === '当期 PSC Rating 记录') {
                level1.headerCustom = 'add'
              }
              result.push(level1)
            }
          }
        } else {
          result.push(column)
        }
      }
      return result
    },
    $handleEmpHireTabs(tabs, data) {
      tabs[0].data = data.filter(item => item.a0010040Date===null || item.a0010040Date===undefined || this.$day(item.a0010040Date).format('YYYY') > this.year)
      tabs[0].label = this.$formatText(tabs[0].format, [tabs[0].data.length])
      tabs[1].data = data.filter(item => item.a0010040 === '10020001' && this.$day(item.a0010040Date).format('YYYY') <= this.year)
      tabs[1].label = this.$formatText(tabs[1].format, [tabs[1].data.length])
    },
    $formatText(text, formatKeys, data) {
      if (formatKeys && formatKeys.length) {
        formatKeys.forEach((formatKey, index) => {
          text = text.replace(`{${index}}`, data ? data[formatKey] : formatKey)
        })
      }
      return text
    },
    $clone(obj) {
      return JSON.parse(JSON.stringify(obj))
    },
    hasPermi(permission) {
      return this.permissionList.includes(permission)
    },
    // 本年度失效Metashars份数弹窗关闭
    ratingModalClosed() {
      this.tableDataRating = false;
      this.loadingRating = false;
    },
    // 本年度失效Metashars份数弹窗显示
    showRatingDetails(row) {
      this.ratingModal.show = true;
      this.loadingRating = true;
      const params = {
        empId: row.id,
        year: this.year
      }
      selectDisabledMetashars(params)
        .then(res => {
          this.loadingRating = false;
          this.tableDataRating = res.data.data || [];
        })
        .catch(error => {
          this.loadingRating = false;
        })
    },
    showBonusDetails(raw) {
      this.loadingBonusDetails = true;
      this.bonusModal.show = true;
      this.tableDataBonusDetails = raw.a0300786Detail;
      this.loadingBonusDetails = false;
    },
    bonusModalClosed() {
      this.bonusModal.show = false;
    },
    deleteElementClosed() {
      this.deleteElementShow = false;
    },
    deleteElementsByEmps(){
      const params = {
        year: this.year,
        emps: this.deleteElementEmps,
        elements: this.deleteElementsChecked
      }
      deleteElementsByEmps(params)
        .then(data => {
        this.$msgSuccess('操作成功')
        this.getTableData()
        this.submitLoading = false
        this.deleteElementShow = false;
      }).catch(() => {
          this.$msgSuccess('操作失败，请稍后重试。')
          this.submitLoading = false
      })
    },
    reCalculation(){
      this.confirmShow = true
      this.confirmTitle = '提示'
      this.confirmContent = `将删除计算项目中的现有数据，重新计算，确定吗?`
      this.confirmFunction = () => {
        this.submitLoading = true
        const dataList = this.checkedList && this.checkedList.length ? this.checkedList : []
        const subIds = dataList.map(item => {
            if(item.subId){
              return item.subId
            }
          })
          const params = {
            subIds: subIds,
            year: this.year
          }
          reCalculationMetashares(params)
            .then(data => {
            this.$msgSuccess('操作成功')
            this.getTableData()
            this.submitLoading = false
          }).catch(() => {
            this.$msgSuccess('操作失败，请稍后重试。')
            this.submitLoading = false
        })
      }
    },
    // 表格列头筛选
    changeFilter(e) {
      this.checkedList = [];
      const { filterData } = e;
      this.queryParams = {...this.queryParams, ...e.filterData}
      this.getTableData();
    },
    handleCommand(val) {
      if (val == 'batchInsert') {
        this.handleImport(val)
      }
      if (val == 'batchUpdate') {
        this.handleImport(val)
      }
      if (val == 'batchDelete') {
        this.handleDelete('')
      }
      if (val == 'batchDeleteElement') {
        this.handleDeleteElement('')
      }
      if(val == 'batchUpdateZjAndXz'){
        this.batchUpdateZjAndXz('')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/air/assets/css/index.scss";
@import "~@/air/assets/css/common.scss";
@import "~@/air/assets/css/biz.scss";
.delete-element {
  flex-wrap: wrap;
  max-height: 300px;
  overflow-y: auto;
  .delete-element-item {
    color: #e6a23c;
    font-size: 12px ;
    padding: 3px 0 ;
    width: 20%;
    text-align: center;
  }
}
.delete-element-checked {
  margin-top: 10px;
  padding: 10px 18px;
}
.app-container {
  ::v-deep .el-input__icon {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.table-top-tips {
  height: 30px;
  background: rgba(42, 97, 255, 0.08);
  border-radius: 4px;
  border: 1px solid #B4C7FF;
  margin-left: 48px;
  padding: 0 20px 0 10px;

  @media screen and (min-width:1920px) {
    width: 340px;
  }

  span {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #303034;
  }
}
.setting-button {
  flex: 0 0 30px;
  width: 30px;
  height: 30px;
  border: 1px solid #CBD0E1;
  border-radius: 50%;
  margin-left: 12px;
  cursor: pointer;

  img {
    width: 14px;
    height: 14px;
  }
}
.emp-form-group {
  border-bottom: 1px solid #DDDDDD;
  margin-bottom: 20px;
}
.letter-form-group {
  border-bottom: 1px dashed #DDDDDD;
  margin-bottom: 20px;

  ::v-deep .el-form-item__label {
    text-align: left;
  }
  &.checkbox {
    ::v-deep .el-form-item__content {
      width: 120px;
    }
  }
}
.item-group {
  height: 100px;
  overflow-x: hidden;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #C2C2C2;
    border-radius: 2px;
    border: 1px solid #C2C2C2;
  }
  .letter-field-item {
    width: 120px;
    height: 30px;
    background: #F4F4F4;
    border: 1px solid #F4F4F4;
    border-radius: 4px;
    transition: all .5s ease;

    &:hover {
      border: 1px solid #2A61FF;

      span {
        color: #2A61FF;
      }
    }
  }
}
.text-left {
  text-align: left !important;
}
.bb-dash {
  border-bottom: 1px dashed #999999;
}
.profile-box {
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 1px dashed #999999;

  .rating-line {
    width: 400px;

    div {
      width: 165px;
    }
  }
}
::v-deep .cell-color-orange {
  span {
    color: #FF9500 !important;
  }
}
::v-deep .cell-color-red {
  span {
    color: #FF3434 !important;
  }
}
</style>
